/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Import_Error_InaccessibleInputs */

const en_zotero_browser_import_error_inaccessible = /** @type {(inputs: Zotero_Browser_Import_Error_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero couldn't provide this file. It's likely saved only on your computer or your Zotero file syncing isn't enabled — open the item in Zotero, make sure the attachment is synced to your account, then try again.`)
};

const es_zotero_browser_import_error_inaccessible = /** @type {(inputs: Zotero_Browser_Import_Error_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero no pudo proporcionar este archivo. Es probable que esté guardado solo en tu computadora o que la sincronización de archivos de Zotero no esté activada: abre el elemento en Zotero, asegúrate de que el adjunto esté sincronizado con tu cuenta y vuelve a intentarlo.`)
};

/**
* | output |
* | --- |
* | "Zotero couldn't provide this file. It's likely saved only on your computer or your Zotero file syncing isn't enabled — open the item in Zotero, make sure the..." |
*
* @param {Zotero_Browser_Import_Error_InaccessibleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_import_error_inaccessible = /** @type {((inputs?: Zotero_Browser_Import_Error_InaccessibleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Import_Error_InaccessibleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_import_error_inaccessible(inputs)
	return en_zotero_browser_import_error_inaccessible(inputs)
});